import { FiChevronRight } from 'react-icons/fi';
import Drawer from 'react-modern-drawer'
import { Col, Input, Label, Row } from 'reactstrap';
import { PRIMARY } from '../../utils/colors';
import { useEffect, useState } from 'react';
import { API_URL } from '../../utils/constants';
import Select from 'react-select';
import DefaultButton from '../Buttons/Default';
import { toast } from 'react-toastify';
import './ViewProperty.css';
import { useTranslation } from 'react-i18next';

function CreateWishRequestDrawer({ isOpen, toggle, onSuccess }) {
  const { t } = useTranslation('wishlist');
  const [categories, setCategories] = useState([]);
  const [states, setStates] = useState([]);
  const [storeLoading, setStoreLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [state, setState] = useState({
    category_id: '',
    state_id: '',
    city_id: '',
    property_for: '',
    price_from: '',
    price_to: ''
  });

  const propertyForOptions = [
    { value: 'rent', label: t("create.purpose.options.rent") },
    { value: 'sale', label: t("create.purpose.options.buy") },
    { value: 'exchange', label: t("create.purpose.options.exchange") }
  ];

  const getCategories = () => {
    fetch(API_URL+'/categories', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {      
      if (data.success) {        
        setCategories(data.categories);
        getStates();
      }
    })
  }

  const getStates = () => {
    fetch(API_URL+'/states', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        setStates(data.states);
      }
    })
  }

  useEffect(() => {
    getCategories();
  }, []);

  const store = () => {
    setStoreLoading(true);
    fetch(API_URL+'/user/wish-requests/store', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(state)
    })
    .then(response => response.json())
    .then(data => {
      setStoreLoading(false);
      if (data.success) {
        toast.success('تم اضافة طلب التمني بنجاح');
        onSuccess();
        toggle();
      } else {
        toast.error(data.message || 'حدث خطأ أثناء اضافة الطلب');
      }
    })
    .catch(error => {
      setStoreLoading(false);
      toast.error('حدث خطأ أثناء اضافة الطلب');
    });
  }

  return(
    <Drawer
      open={isOpen}
      onClose={toggle}
      direction='right'
      size={'50%'}
      zIndex={9000}
      duration={200}
    >
      <div className='border-bottom p-3 align-items-center d-flex'>
        <Col xs="2">
          <FiChevronRight color={PRIMARY} size={28} onClick={toggle} />
        </Col>
        <Col xs="8" className='text-center'>
          <h4 className='mb-0'>{t("create.title")}</h4>
        </Col>
      </div>

      <div className="p-3">
        <h4 className='text-primary mb-4'>
          {t("create.description")}
        </h4>

        <Row>
          <Col xs="6" className='mb-4'>
            <Label>{t("create.category.label")}</Label>
            <Select 
              placeholder={t("create.category.placeholder")} 
              options={categories.map(cat => ({ value: cat.id, label: cat.name_ar }))} 
              onChange={(option) => setState({ ...state, category_id: option.value })}
            />
          </Col>
          <Col xs="6" className='mb-4'>
            <Label>{t("create.city.label")}</Label>
            <Select 
              placeholder={t("create.city.placeholder")} 
              options={states.map(state => ({ value: state.id, label: state.name_ar, cities: state.cities }))} 
              onChange={(option) => [setState({ ...state, state_id: option.value }), setCities(option.cities)]}
            />
          </Col>
        </Row>

        {cities?.length > 0 &&
          <div className="mb-3">
            <Label>{t("create.city.label")}</Label>
            <Select 
              placeholder={t("create.city.placeholder")} 
              options={cities.map(city => ({ value: city.id, label: city.name_ar }))} 
              onChange={(option) => setState({ ...state, city_id: option.value })}
            />
          </div>
        }

        <div className="mb-3">
          <Label>{t("create.purpose.label")}</Label>
          <Select 
            placeholder={t("create.purpose.placeholder")} 
            options={propertyForOptions} 
            onChange={(option) => setState({ ...state, property_for: option.value })}
          />
        </div>

        <Row>
          <Col md="6" className='mb-4'>
            <Label>{t("create.price_from.label")}</Label>
            <Input 
              type='number' 
              value={state.price_from || ''} 
              onChange={(e) => setState({ ...state, price_from: e.target.value })} 
              dir='rtl'
            />
          </Col>
          <Col md="6" className='mb-4'>
            <Label>{t("create.price_to.label")}</Label>
            <Input 
              type='number' 
              value={state.price_to || ''} 
              onChange={(e) => setState({ ...state, price_to: e.target.value })} 
              dir='rtl'
            />
          </Col>
        </Row>

        <div className="text-center">
          <DefaultButton
            loading={storeLoading}
            onClick={store}
            disabled={
              storeLoading ||
              !state.category_id || 
              !state.state_id || 
              !state.city_id || 
              !state.property_for || 
              (state.price_from === '' && state.price_to === '')
            }
          >
            {t("create.button")}
          </DefaultButton>
        </div>
      </div>
    </Drawer>
  );
}

export default CreateWishRequestDrawer;